import axiosInstance, { microServices } from 'network/apis/index'
import { SuccessMessage } from 'network/messageTranslationHelpers/messages'
import { METHOD_TYPES } from 'utils/constants/index'

export const placeBetCrashGameService = (data) => {
  return axiosInstance(METHOD_TYPES.post, 'game/crash/power-of-thor/place-bet', data, {
    server: microServices.USER_URL
    // successMessage: SuccessMessage.betPlacedSuccessfully
  })
}
export const escapeCrashBetService = (data) => {
  return axiosInstance(METHOD_TYPES.post, 'game/crash/power-of-thor/player-escape', data, {
    server: microServices.USER_URL
  })
}

export const cancelCrashBetService = (data) => {
  return axiosInstance(METHOD_TYPES.post, 'game/crash/power-of-thor/cancel-bet', data, {
    server: microServices.USER_URL,
    successMessage: SuccessMessage.betCancelledSuccessfully
  })
}
export const getAllRoundHistoryService = () => {
  return axiosInstance(METHOD_TYPES.get, '/game/crash/power-of-thor/get-history', {
    server: microServices.USER_URL
  })
}

export const getMyBetsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/game/crash/power-of-thor/my-bets', {}, {
    params,
    server: microServices.USER_URL
  })
}
export const getPreviousRoundBetsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, 'game/crash/power-of-thor/previous-round-placed-bets', {}, {
    params,
    server: microServices.USER_URL
  })
}

export const getTopBetsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/game/crash/power-of-thor/top-bets', {}, {
    params,
    server: microServices.USER_URL
  })
}

export const verifyProvableFairCrashService = (data) => {
  return axiosInstance(METHOD_TYPES.post, 'game/crash/power-of-thor/check-fairness', data, {
    server: microServices.USER_URL
  })
}
